import { useEffect, useState } from 'react';
import FavoriteService from '../../../../services/favorites';
import { useFavoriteStore } from '../../../../common/hooks/useFavoriteStore';
import useServiceClients from '../../../../common/hooks/useServiceClients';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import useSplunkLogger from '../../../../common/hooks/useSplunkLogger';
import { splunk_message } from '../../../../common/splunk_constant';

const useFavorite = () => {
  const [favItems, setFavItems] = useState([] as Array<string>);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState({message:''});
  const { t } = useTranslation();

  const favStore = useFavoriteStore();
  const { visionBffClient } = useServiceClients();
  const { splunkLogger } = useSplunkLogger();
  const favoriteService = new FavoriteService(visionBffClient, splunkLogger);
  useEffect(() => {
    if (favStore.userFavorites != null) {
      const favItems = favStore.userFavorites.lineItems?.map((item: any) => item.variant?.sku);
      setFavItems(favItems);
    }
  }, []);

  const isFavoriteSelected = (itemSku: string) => {
    const skuList = favStore.userFavorites?.lineItems?.map((item: any) => item.variant?.sku);
    if (skuList && skuList.includes(itemSku)) {
      return true;
    } else {
      return false;
    }
  };

  const handleFavorite = async (isSelected: boolean, itemSku:string) => {
    setLoading(true);
    try {
      let response;
      if (!isSelected) {
        response = await favoriteService.addFavorite([itemSku]);
        setLoading(false);
      } else {
        response = await favoriteService.removeFavorite([itemSku]);
        setLoading(false);
      }
      if (response != undefined) {
        const favItems = response?.lineItems?.map((item: any) => item.variant?.sku);
        setFavItems(favItems);
        favStore.setUserFavorites(response);
        setError({message:''});
      } else {
        setError({ message: isSelected ? t('favorites.error.remove.message') : t('favorites.error.add.message') });
      }
      splunkLogger({
        logType: 'info',
        data: splunk_message.SUCCESS.HANDLE_FAVORITE_SUCCESS
      });
    } catch (error) {
      splunkLogger({
        logType: 'error',
        data: { ...splunk_message.ERROR.HANDLE_FAVORITE_ERROR, error }
      });
      setLoading(false);
      setError({ message: isSelected ? t('favorites.error.remove.message') : t('favorites.error.add.message') });
      throw error;
    }
  };

  return {
    handleFavorite,
    isFavoriteSelected,
    loading,
    favItems,
    error
  };
};

export default useFavorite;
